import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const InternReportBlueprint = [
  {
    type: 'output',
    key: 'view_year',
    div: 3,
    default: '-',
    label: '學年期：',
  },
  {
    type: 'input',
    key: 'course_title',
    div: 3,
    required: true,
    label: '課名：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'student_name',
    div: 3,
    disabled: true,
    required: true,
    label: '姓名：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'student_account',
    div: 3,
    disabled: true,
    required: true,
    label: '學號：',
    max_length: 500,
  },
  {
    key: 'department_id',
    type: 'select',
    div: 3,
    disabled: true,
    label: '就讀系所：',
  },
  {
    type: 'input',
    key: 'department_grade',
    div: 3,
    required: true,
    label: '系級：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'internship',
    div: 2,
    disabled: true,
    required: true,
    label: '實習機構：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'intern_teacher',
    div: 2,
    required: true,
    label: '實習輔導老師：',
    max_length: 500,
  },
];
